/* Injects sections/chumzy-cart-boost.liquid into the cart drawer and the cart page.
   The theme's own cart files are untouched: the drawer replaces its innerHTML on every
   update, so a MutationObserver re-injects when our nodes disappear.
   Shipping Protection (knowledge/tech/ship-protect.md) is opt-in: nothing here ever ticks it
   on its own. decide() is pure so scripts/tests/test_ship_protect.py can run it under node. */
(() => {
  /* cart = {real_count, protect_qty, protect_key}; want = true (ticked), false (unticked) or
     null (after a re-render). Returns {action: 'add'|'remove'|'fix_qty'|'none'}. */
  function decide(cart, want) {
    const real = Number(cart.real_count) || 0;
    const qty = Number(cart.protect_qty) || 0;
    if (real <= 0) return { action: qty > 0 ? 'remove' : 'none' };
    if (want === true && qty === 0) return { action: 'add' };
    if (want === false && qty > 0) return { action: 'remove' };
    if (qty > 1) return { action: 'fix_qty' };
    return { action: 'none' };
  }

  if (typeof document === 'undefined') {
    if (typeof module === 'object') module.exports = { decide };
    return;
  }

  const SECTION = 'chumzy-cart-boost';
  const PROTECT_LINK = 'a[href*="/products/shipping-protection"]';
  const TARGETS = [
    { host: '#CartDrawer', top: '.drawer__footer', set: '.drawer__contents' },
    { host: '#main-cart-footer', top: '.cart__blocks', set: '.cart__blocks' },
  ];
  const observers = [];
  let timer = null;
  let busy = false;

  const currency = () => (window.Shopify && Shopify.currency) || { active: 'JPY', rate: '1' };

  function fmt(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency().active,
    }).format(cents / 100);
  }

  function paintShip(scope) {
    const rate = parseFloat(currency().rate) || 1;
    const row = scope.querySelector('[data-cz-ship-row]');
    scope.querySelectorAll('[data-cz-ship]').forEach((el) => {
      const total = Number(el.dataset.total);
      const threshold = Math.round(Number(el.dataset.threshold) * 100 * rate);
      const alwaysFree = threshold <= 0;
      const left = threshold - total;
      el.querySelector('[data-cz-ship-text]').innerHTML = alwaysFree
        ? '<strong>Free shipping</strong> on every order'
        : left > 0
          ? `You're <strong>${fmt(left)}</strong> away from free shipping`
          : "You've unlocked <strong>free shipping</strong>";
      el.querySelector('[data-cz-ship-fill]').style.width = alwaysFree
        ? '100%'
        : `${Math.min(100, (total / threshold) * 100)}%`;
      el.classList.toggle('is-done', alwaysFree || left <= 0);
      el.hidden = Boolean(row) && left <= 0;
      if (row) row.hidden = left > 0;
    });
  }

  /* The theme's own line row for the protection keeps its × button but loses the stepper. */
  function markProtectLines() {
    document.querySelectorAll(PROTECT_LINK).forEach((a) => {
      const line = a.closest('tr, li, .cart-item');
      if (line) line.setAttribute('data-cz-protect-line', '');
    });
  }

  function stateOf(boost) {
    const el = boost && boost.querySelector('[data-cz-state]');
    if (!el) return null;
    return {
      real_count: el.dataset.realCount,
      protect_qty: el.dataset.protectQty,
      protect_key: el.dataset.protectKey,
    };
  }

  const drawerEl = () => document.querySelector('cart-drawer');
  const onCartPage = () => Boolean(document.getElementById('main-cart-footer'));

  function cartBody(body) {
    const drawer = drawerEl();
    if (drawer && !onCartPage() && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cartBody(body)),
    });
    if (!res.ok) throw new Error(`${url} ${res.status}`);
    const data = await res.json();
    const drawer = drawerEl();
    if (onCartPage() || !drawer || !data.sections) {
      window.location.reload();
      return;
    }
    drawer.renderContents(data);
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SECTION });
    }
  }

  const cartUrl = (name) => `${(window.routes && routes[`cart_${name}_url`]) || `/cart/${name}`}.js`;

  async function apply(action, cart, variantId) {
    if (action === 'add') return post(cartUrl('add'), { items: [{ id: Number(variantId), quantity: 1 }] });
    if (action === 'remove') return post(cartUrl('change'), { id: cart.protect_key, quantity: 0 });
    if (action === 'fix_qty') return post(cartUrl('change'), { id: cart.protect_key, quantity: 1 });
    return undefined;
  }

  function setObserving(on) {
    observers.forEach(({ observer, host }) => {
      if (on) observer.observe(host, { childList: true, subtree: true });
      else observer.disconnect();
    });
  }

  function place(boost) {
    TARGETS.forEach((t) => {
      const host = document.querySelector(t.host);
      if (!host) return;
      host.querySelectorAll('[data-cz-boost-top], [data-cz-boost-set]').forEach((n) => n.remove());
      if (!boost) return;
      const topSlot = host.querySelector(t.top);
      const setSlot = host.querySelector(t.set);
      const top = boost.querySelector('[data-cz-boost-top]');
      const set = boost.querySelector('[data-cz-boost-set]');
      if (topSlot && top) topSlot.prepend(top.cloneNode(true));
      if (setSlot && set) setSlot.append(set.cloneNode(true));
      paintShip(host);
    });
  }

  async function refresh() {
    if (busy) return;
    busy = true;
    try {
      const res = await fetch(`${window.location.pathname}?section_id=${SECTION}`);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      setObserving(false);
      const boost = doc.querySelector('.cz-boost');
      place(boost);
      markProtectLines();
      const cart = stateOf(boost) || { real_count: 0, protect_qty: 0, protect_key: '' };
      const { action } = decide(cart, null);
      if (action === 'remove' && !cart.protect_key) return;
      if (action !== 'none') apply(action, cart).catch(() => {});
    } catch (e) {
      /* The cart still works without the boost. */
    } finally {
      setObserving(true);
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  async function add(btn) {
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await post(cartUrl('add'), { items: [{ id: Number(btn.dataset.czBoostAdd), quantity: 1 }] });
    } catch (e) {
      window.location.href = (window.routes && routes.cart_url) || '/cart';
    }
  }

  async function toggleProtect(input) {
    const label = input.closest('[data-cz-protect]');
    const boost = input.closest('[data-cz-state]');
    const cart = {
      real_count: (boost && boost.dataset.realCount) || 1,
      protect_qty: (boost && boost.dataset.protectQty) || (label.dataset.key ? 1 : 0),
      protect_key: label.dataset.key,
    };
    const { action } = decide(cart, input.checked);
    if (action === 'none') return;
    input.disabled = true;
    label.classList.add('is-busy');
    try {
      await apply(action, cart, label.dataset.variant);
    } catch (e) {
      input.checked = !input.checked;
      input.disabled = false;
      label.classList.remove('is-busy');
    }
  }

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cz-protect] input[type="checkbox"]');
    if (input) toggleProtect(input);
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cz-boost-add]');
    if (!btn) return;
    e.preventDefault();
    add(btn);
  });

  function init() {
    TARGETS.forEach((t) => {
      const host = document.querySelector(t.host);
      if (!host) return;
      const observer = new MutationObserver(() => {
        if (!host.querySelector('[data-cz-boost-top]')) schedule();
      });
      observers.push({ observer, host });
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
